
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import Playground from '@ecl/website-components/Playground';
import Blockquote from '@ecl/ec-react-component-blockquote';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Playground system="ec" selectedKind="components-blockquote" selectedStory="default" mdxType="Playground">
  <Blockquote author="President Juncker" citation="An interconnected grid will help deliver the ultimate goal of the Energy Union, to ensure affordable, secure and sustainable energy, and also growth across the EU." mdxType="Blockquote" />
    </Playground>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;